import React, { useState, useEffect } from "react";
import { Wheel } from "react-custom-roulette";
import t from "../translate";
import './spin.css';
import { spin } from "../api/api";
import { useNotification } from "./NotificationProvider";

const data = [
  { option: "+1 ⭐", message: 'You win +1 ⭐' },
  { option: "+3 ⭐", message: 'You win +3 ⭐' },
  { option: "+1 ⭐", message: 'You win +1 ⭐' },
  { option: "+5 ⭐", message: 'You win +5 ⭐' },
  { option: "+1 ⭐", message: 'You win +1 ⭐' },
  { option: "+1 👥", message: 'You win +1 👥 active friends' },
];

const WheelOfFortune = () => {
  const { addNotification } = useNotification();

  const [isSpinning, setIsSpinning] = useState(false);
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  const handleSpinClick = async () => {
    if (isSpinning) return;

    try {
      setIsSpinning(true);
      const result = await spin();

      if (
        typeof result.prizeNumber === "number" &&
        result.prizeNumber >= 0 &&
        result.prizeNumber < data.length
      ) {
        setPrizeNumber(result.prizeNumber);
        setMustSpin(true);
      } else {
        console.error("Невірний prizeNumber:", result);
        setIsSpinning(false);
      }
    } catch (error) {
      addNotification("error", error.response?.data?.message || "Unknown error");
      setIsSpinning(false);
    }
  };

  const handleWatchAdAndSpin = () => {
    if (typeof show_9248323 === "function") {
      // eslint-disable-next-line no-undef
      show_9248323()
        .then(() => {
          // користувач переглянув рекламу
          handleSpinClick();
        })
        .catch(() => {
          // реклама не показалась або була закрита
          handleSpinClick(); // або не викликати, якщо не потрібно крутити без реклами
        });
    } else {
      console.error("show_9248323 is not defined");
      addNotification("error", "Ad not available");
    }
  };

  const formatTime = (ms) => {
    const hours = Math.floor(ms / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  useEffect(() => {
    const lastPurchaseTime = localStorage.getItem('lastPurchaseTime');
    if (lastPurchaseTime) {
      const savedTime = new Date(lastPurchaseTime).getTime();
      const timeDiff = 60 * 60 * 1000 - (Date.now() - savedTime);
      if (timeDiff > 0) {
        setIsButtonDisabled(true);
        setTimeLeft(timeDiff);
      } else {
        localStorage.removeItem('lastPurchaseTime');
      }
    }
  }, []);

  useEffect(() => {
    let timer;
    if (timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1000) {
            setIsButtonDisabled(false);
            localStorage.removeItem('lastPurchaseTime');
            return 0;
          }
          return prev - 1000;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [timeLeft]);

  return (
    <div className="spin-page">
      <div className="spin-content">
        <h1>{t(localStorage.getItem('lang') || 'en', 'spin_name')}</h1>
        <h4>{t(localStorage.getItem('lang') || 'en', 'spin_description')}</h4>

        <div className="tap-button-container">
          <Wheel
            mustStartSpinning={mustSpin}
            prizeNumber={prizeNumber}
            data={data}
            outerBorderColor="#f2f2f2"
            outerBorderWidth={10}
            innerBorderColor="#f2f2f2"
            radiusLineColor="#dedede"
            radiusLineWidth={1}
            fontSize={12}
            textColors={["#ffffff"]}
            backgroundColors={[
              "#7F00FF", "#E100FF", "#9D50BB", "#6E48AA", "#B06AB3", "#833AB4", "#BA68C8", "#AB47BC", "#8E24AA"
            ]}
            onStopSpinning={() => {
              console.log("Рулетка зупинилась на:", prizeNumber);
              setMustSpin(false);
              setIsSpinning(false);
              const lastPurchaseTime = new Date()
              const savedTime = new Date(lastPurchaseTime).getTime();
              localStorage.setItem("lastPurchaseTime", lastPurchaseTime);
              const timeDiff = 60 * 60 * 1000 - (Date.now() - savedTime);
              setIsButtonDisabled(true);
              setTimeLeft(timeDiff);
              addNotification('success', data[prizeNumber].message);
            }}
          />
          <button
            className="spin-button"
            onClick={handleWatchAdAndSpin}
            disabled={mustSpin || isButtonDisabled}
          >
            {isButtonDisabled
              ? `${t(localStorage.getItem('lang') || 'en', 'spin_wait')} (${formatTime(timeLeft)})`
              : `🎥  ${t(localStorage.getItem('lang') || 'en', 'spin_button')}`}
          </button>
        </div>

        <div className="timer-counter">
          {timeLeft > 0 && !mustSpin ? (
            <h5>{t(localStorage.getItem('lang') || 'en', 'spin_wait_time')} {formatTime(timeLeft)}</h5>
          ) : !mustSpin ? (
            <h5>{t(localStorage.getItem('lang') || 'en', 'spin_win')} {data[prizeNumber].option}</h5>
          ) : (
            <h5>{t(localStorage.getItem('lang') || 'en', 'spin')}</h5>
          )}
        </div>
      </div>
    </div>
  );
};

export default WheelOfFortune;
